module.exports = __webpack_public_path__ + "static/media/Blinker-Regular.9d149686.ttf";